import Image, {ImageData} from "@/types/clients/esquire/data/general/image";

export type FlatImageData = {
  id: number;
  flat_type: string;
  image_id: string;
  is_thumbnail: string;
  alt: string;
  order: string;
  image?: ImageData | null;
};

export default class FlatImage {
  public id: number;
  public flatType: string;
  public imageId: string;
  public isThumbnail: string;
  public alt: string;
  public order: string;
  public image: Image|null;

  constructor(data: FlatImageData) {
    this.id = data.id as number;
    this.flatType = data.flat_type as string;
    this.imageId = data.image_id as string;
    this.isThumbnail = data.is_thumbnail as string;
    this.alt = data.alt as string;
    this.order = data.order as string;
    this.image = data.image ? new Image(data.image) : null;
  }

  toDTO(): FlatImageData {
    return {
      id: this.id,
      flat_type: this.flatType,
      image_id: this.imageId,
      is_thumbnail: this.isThumbnail,
      alt: this.alt,
      order: this.order,
      image: this.image ? this.image.toDTO() : null
    };
  }

  static fromDTO(dto: FlatImageData): FlatImage {
    return new FlatImage(dto);
  }

}
